import { Component, ChangeDetectionStrategy, inject, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSettings } from '@services/settings/app-settings.service';
import { AppNavService, PendingInboxItem } from '@services/core/app-nav.service';
import { BottomSheetComponent } from '../bottom-sheet/bottom-sheet.component';

@Component({
	selector: 'app-bottom-nav',
	standalone: true,
	imports: [CommonModule, BottomSheetComponent],
	templateUrl: './bottom-nav.component.html',
	styleUrl: './bottom-nav.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class BottomNavComponent {
	appSidebarMobileToggled = output<boolean>();
	appSettings = inject(AppSettings);
	readonly nav = inject(AppNavService);

	sheet = signal<'notices' | 'roles' | null>(null);

	toggleSheet(name: 'notices' | 'roles', event?: Event): void {
		event?.preventDefault();
		event?.stopPropagation();
		if (this.appSettings.appSidebarMobileToggled) {
			this.appSidebarMobileToggled.emit(true);
		}
		if (name === 'notices') this.nav.hub.markAllRead();
		this.sheet.update((current) => current === name ? null : name);
	}

	closeSheet(): void {
		this.sheet.set(null);
	}

	openMenu(): void {
		this.closeSheet();
		this.appSidebarMobileToggled.emit(true);
	}

	selectRole(role: any): void {
		this.nav.changeRole(role);
		this.closeSheet();
	}

	openPending(item: PendingInboxItem): void {
		this.closeSheet();
		this.nav.openPending(item);
	}

	openInbox(): void {
		this.closeSheet();
		this.nav.openInbox();
	}
}
